module.exports = __webpack_public_path__ + "static2/img/logo.3ddf8d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 55
// module chunks = 171